import React from "react";
import { cx } from "../../utils/classNames";

const statusVariantMap = {
  active: "success",
  scheduled: "warning",
  expired: "danger",
  disabled: "muted",
};

export function badgeVariantFromStatus(status, fallback = "primary") {
  if (!status) return fallback;
  const key = String(status).toLowerCase();
  return statusVariantMap[key] || fallback;
}

export function Badge({ variant = "muted", children, className }) {
  return <span className={cx("badge", `badge-${variant}`, className)}>{children}</span>;
}

export default Badge;
